module.exports = __webpack_public_path__ + "media/images/categoryIcons/immigration_icon-760494e10aac07e5c0735b5f14df70dd.svg";